var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bindtips_popup"},[_c('p',[_vm._v("该账号当前没有绑定游戏账号角色，")]),_c('p',[_vm._v("请前往绑定")]),_c('el-button',{staticClass:"bind_btn",attrs:{"type":"primary"},on:{"click":_vm.gotoBind}},[_vm._v("确定")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }